import * as React from "react";
import { Block } from "src/utils/blocknote";
import styled from "styled-components";
import { Content } from "./Content";

interface Props {
  completed: boolean;
  onChange(completed: boolean): void;
  content: Block["content"];
}

export function Checklist({ completed, onChange, content }: Props) {
  return (
    <Container
      data-testid="checklist-item"
      data-checked={completed}
      onClick={() => onChange(!completed)}
    >
      <Checkbox>{completed && <Filled />}</Checkbox>
      <Content content={content} />
    </Container>
  );
}

const Container = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  padding: 0 8px;
  gap: 8px;
`;

const Checkbox = styled.div`
  border: 1px solid #aaa;
  border-radius: 3px;
  width: 18px;
  height: 18px;
  padding: 3px;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const Filled = styled.div`
  background: #aaa;
  width: 100%;
  height: 100%;
`;
